<template>
    <!-- THIS PAGE WOULD BE USED IF A USER WAS CREATED BY ADMIN DIRECTLY ON COGNITO, SO THAT WHEN LOGGING IN WITH TEMP PASS, THEY WOULD BE ASKED TO COMPLETE REG -->
    <main-layout>
        <div class="completeDiv">
            <div class="container"> 
                <H1 class="pageTitle">COMPLETE REGISTRATION</H1>
            <div class="columns">         
                <div class="column">
                    <div class="limitWidth top40">
                        <form class="form accSettingsForm" v-on:submit.prevent="submitForm" v-if="showForm">
                            <div class="field" :class="{formError: errors.first('fName') }">
                                First Name:*
                                <input type="text" class="input is-warning" name="fName"  v-validate="'required'" v-model="form.fName" />
                                <p class="help is-danger" >
                                    {{ errors.first('fName') }}
                                </p>
                            </div>
                            <div class="field" :class="{formError: errors.first('lName') }">
                                Last Name:*
                                <input type="text" class="input is-warning" name="lName" v-validate="'required'" v-model="form.lName"/>
                                <p class="help is-danger" >
                                    {{ errors.first('lName') }}
                                </p>
                            </div>
                            <div class="field">
                                Company:
                                <input type="text" class="input is-warning" name="Company" v-model="form.company"/>
                            </div>
                            <div class="field" :class="{formError: errors.first('City') }">
                                City:*
                                <input type="text" class="input is-warning" name="City" v-validate="'required'" v-model="form.city" autocomplete="city"/>
                                <p class="help is-danger" >
                                    {{ errors.first('City') }}
                                </p>
                            </div>
                            <div class="field" :class="{formError: errors.first('Country') }">
                                Country:*<br/>
                                <div class="select is-warning width100">
                                    <select name="Country" class="width100"  v-validate="'required'" v-model="form.country">
                                        <option disabled value="">Select...</option>
                                        <option v-for="item in countries" :key="item.code" v-bind:value="item.code">{{item.name}}</option>
                                    </select>
                                </div>
                                <p class="help is-danger" >
                                    {{ errors.first('Country') }}
                                </p>
                            </div>
                            <div class="field" :class="{formError: errors.first('Password') }" >
                                Password:*
                                <input class="input is-warning" type="password" name="Password" v-validate="{required: true, min:8, regex: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[$@$!%*#?&])/}" v-model="form.password"/>
                                <p class="help is-danger" >
                                    {{ errors.first('Password') }}
                                </p>
                                
                            </div>
                            <div class="field" :class="{formError: errors.first('password2') }">
                                Confirm Password:*
                                <input class="input is-warning" type="password" name="password2" v-validate="{required:true, is: form.password}" />
                                <p class="help is-danger" >
                                    {{ errors.first('password2') }}
                                </p>
                                <span class="is-size-8 has-text-weight-light">(At least 8 characters long, at least one number, at least one lowercase letter, at least one uppercase letter and at least one special character)</span>
                            </div>
                            <div class="field" :class="{formError: errors.first('terms') }">
                                <label class="checkbox">
                                    <input type="checkbox" name="terms" v-validate="'required'" v-model="form.terms">
                                    *I agree to the <a href="#" class="has-text-warning"><b>terms and conditions</b></a>
                                    <p class="help is-danger" >
                                        {{ errors.first('terms') }}
                                    </p>
                                </label>
        
                            </div>
                            <div class="field">
                                 <div id="recaptcha-main" class="g-recaptcha" data-sitekey="6LdPJ7caAAAAABSJZ2-94XxGY_h_7Ux38kc1YfYc"></div>
                            </div>
                            <div class="field">
                                <button id="save" type="submit" class="button is-warning top10">SUBMIT</button>
                            </div>
                        </form>
        
                        <div v-if="!showForm">
                            <div class="subtitle has-text-dark is-size-3">
                                <b>Thank you for registering! </b>
                            </div>
                            <div class="has-text-dark is-size-5">
                                Your information has been saved and your registration is complete.<br><br> 
                                
                                <div class="is-size-4 roundPad has-background-turk has-text-white">
                                    <br>
                                    If you are trying a slink for free, it has has been activated and is ready to go.<br><br>
                                    <b>Change it's redirection URL or configure it's subslinks via the <span class="has-text-primary handCursor" @click="$router.push('/mng')">Manage Sevices</span> page.</b>
                                     <br> <br>
                                </div>
                            </div>
        
                            <div class="top20">
                                <button class="button is-turk" @click="login">LOG IN</button>
                            </div>
        
                        </div>
                    </div>
    
    </div>
    
                 <div class="column">
                 <!--  <img src="@/assets/img/regIcon.png" class="top160" width="550" /> -->
                </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import countries from '../STATIC/countries.js'
var AmazonCognitoIdentity = require('amazon-cognito-identity-js')
export default {
  components: {
    MainLayout
  },
  data: function () {
    var self = this
    var form = {
      fName: '',
      lName: '',
      company: '',
      country: '',
      city: '',
      password: '',
      terms: false
    }

    return {
      form: form,
      showForm: true,
      countries: countries,
      recaptcha: false,
    }
  },

  mounted: function(){

    function configRecaptcha(){

    }

    this.$root.loadScript('https://www.google.com/recaptcha/api.js', configRecaptcha)

    setTimeout(() => {
        grecaptcha.render('recaptcha-main'); // 'recaptcha-main' is the id that was assigned to the widget
    }, 200);
  },

  methods: {
    submitForm: function () {
      var self = this
      this.$validator.validateAll().then(res => {
        if (res) {
          doReCaptcha()
        } else {
          this.$root.showModalOK({message: 'Please correct the errors or omissions on the form'})
        }
      })

      function doReCaptcha(){
              let rc = grecaptcha.getResponse()

              if(rc == '' || rc == undefined){
                  self.$root.showModalOK({message: "Please complete the - I'm not a Robot - verification."})
                  return
              }

              function w(d){
                  if(d.r == 'ok'){
                      doComplete()
                  } else {
                      self.$root.showModalOK({message: 'Robot Verification returned an error, please reload the page and try again.'})
                  }
              }

              function n(){
              //
              }

              self.$root.apiClient.post('', {token: rc}, w, n)
      }

      function doComplete () {
        az.addRemSpinner(true, 'id', 'save');
        var attributes = {
          given_name: self.form.fName,
          family_name: self.form.lName,
          'custom:company': self.form.company,
          'custom:city': self.form.city,
          'custom:countryCode': self.form.country
        }
        self.$root.azCognito.completeNewPasswordChallenge(self.$route.params.user, self.form.password, attributes, completeAttrsCallback)

        function completeAttrsCallback (result, obj) {
          az.addRemSpinner(false, 'id', 'save');
          if (result == 'error') {
            self.$root.showModalOK({message: 'There was an error processing your request. Please try again later or contact support.'})
            return
          }
          self.showForm = false
        }
      }
    },
    login: function () {
      this.$root.showModalLogin({})
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/CompleteReg.vue